import { render, staticRenderFns } from "./shopInformation.vue?vue&type=template&id=50b79570&scoped=true&"
import script from "./shopInformation.vue?vue&type=script&lang=js&"
export * from "./shopInformation.vue?vue&type=script&lang=js&"
import style0 from "./shopInformation.vue?vue&type=style&index=0&id=50b79570&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b79570",
  null
  
)

export default component.exports